import { galileo } from '@galileo/galileo-web-sdk';
import { FeatureFlag } from './featureFlag.enum';
import { ENV } from '../constants';
import { EXPRESS_ENVIRONMENT } from '../../types';
import { UserGalileoVars } from '../../types/store/user';

export type Feature = Readonly<UserGalileoVars>;

const GALILEO_PROJECT_NAME = 'express/';

const featureFlagDefaults = Object.keys(FeatureFlag).reduce(
  (map: Record<string, boolean>, key: string) => ({
    ...map,
    [`${GALILEO_PROJECT_NAME}${FeatureFlag[key as keyof typeof FeatureFlag]}`]: true
  }),
  {}
);

export const getGalileoFlags = async (tags: Record<string, number | string>) => {
  const isStaging = [EXPRESS_ENVIRONMENT.development, EXPRESS_ENVIRONMENT.staging].includes(ENV);
  const env = isStaging ? 'dev' : 'prd';
  galileo.setEnvironment(env);
  galileo.setTTL(0);

  const featureFlags = await galileo.getMany(featureFlagDefaults, tags);

  const featureList = Object.entries(featureFlags).map(([key, value]) => {
    const featureName = key.split(GALILEO_PROJECT_NAME)[1];
    return { [featureName]: value };
  });
  return Object.assign({}, ...featureList);
};
